var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoElbphilharmonieWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 63,
    viewBox: "0 0 52 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1711_1647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8101 42.56H13.3601V44.67H24.8101V42.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.45 36.34H0V37.91H11.45V36.34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8101 52.02H13.3601V53.02H24.8101V52.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.45 42.55H0V43.55H11.45V42.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.45 49.04H0V49.62H11.45V49.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5201 36.35H40.0701V39.49H51.5201V36.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8101 36.34H13.3601V39.48H24.8101V36.34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5201 52.02H40.0701V53.02H51.5201V52.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5201 62.07H40.0701V62.36H51.5201V62.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.16 42.56H26.71V43.56H38.16V42.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.16 49H26.71V49.58H38.16V49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.79 2.95C30.6 12.29 20.06 15.46 13.57 9.69C7.45 16.39 0 12.78 0 12.78V31.11H51.51V0C51.51 0 45.38 8.98 35.78 2.95",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1711_1647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.52,
    height: 62.36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoElbphilharmonieWhite);
export default __webpack_public_path__ + "static/media/logo-elbphilharmonie-white.b0ba4ace373e4a2b578f5bea6e4b9603.svg";
export { ForwardRef as ReactComponent };